import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import Profile from '../../components/profile/Profile'
import profileActions from '../../actions/profile/profile'
import { openErrorMessageModal } from '../../actions/modals/messageModal'
import TrackingContainer from '../../containers/tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.profile,
    ...state.auth,
    combos: {
      UOTreeCombo: state.combos.UOTreeCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      ...profileActions,
      openErrorMessageModal
    }, dispatch)
  }
}

var decoratedComponent = TrackingContainer(Profile, true)
export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
